import { render, staticRenderFns } from "./repayment_details.vue?vue&type=template&id=0d2bc0ae&scoped=true&"
import script from "./repayment_details.vue?vue&type=script&lang=js&"
export * from "./repayment_details.vue?vue&type=script&lang=js&"
import style0 from "./repayment_details.vue?vue&type=style&index=0&id=0d2bc0ae&prod&lang=scss&scoped=true&"
import style1 from "./repayment_details.vue?vue&type=style&index=1&id=0d2bc0ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2bc0ae",
  null
  
)

export default component.exports